import { render, staticRenderFns } from "./ScrollNumber.vue?vue&type=template&id=5cfbf377&scoped=true"
import script from "./ScrollNumber.vue?vue&type=script&lang=js"
export * from "./ScrollNumber.vue?vue&type=script&lang=js"
import style0 from "./ScrollNumber.vue?vue&type=style&index=0&id=5cfbf377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbf377",
  null
  
)

export default component.exports